import { type ReactNode, useId } from 'react';
import classes from './Section.module.css';

export interface SectionProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  id?: string;
  /** LedgerRow, SwitchRow and DataTable bring their own top line; wrap free content in SectionBody. */
  children?: ReactNode;
}

export function Section({ title, subtitle, actions, id, children }: SectionProps) {
  const headingId = useId();
  return (
    <section id={id} className={classes.section} aria-labelledby={headingId}>
      <div className={classes.head}>
        <div className={classes.titles}>
          <h2 id={headingId} className={classes.title}>
            {title}
          </h2>
          {subtitle && <span className={classes.subtitle}>{subtitle}</span>}
        </div>
        {actions && <div className={classes.actions}>{actions}</div>}
      </div>
      {children}
    </section>
  );
}

/** Free content inside a Section, padded like a ledger row. */
export function SectionBody({ children }: { children: ReactNode }) {
  return <div className={classes.pad}>{children}</div>;
}
